<template functional>
  <div>
    <strong v-if="props.row.Time > 0" class="red">{{ props.row.Time }}</strong>
    <strong v-else></strong>
  </div>
</template>

<script>
export default {
  name: "DelayedTasks"
};
</script>

<style lang="scss" scoped>
.red {
  color: red;
}
</style>
